<template>
  <v-card>
    <v-card-text v-if="!isLoading">
      <div v-for="notification in notifications" :key="notification.id">
        <EmailNotification
          v-if="notification.stringId === 'NIGHTLYSALE'"
          :notification="notification"
          :LocationId="LocationId"
          @reload="loadNotifications()"
        />

        <SaleAlertNotification
          class="py-2"
          v-if="notification.stringId === 'SALESALERT'"
          :notification="notification"
          :LocationId="LocationId"
          @reload="loadNotifications()"
        />


        <!-- Invoice Delete Notify is now moved to SaleAlertNotification -->

        <!-- <InvoiceDeleteNotification
          class="py-2"
          v-if="notification.stringId === 'INVOICEDELETED'"
          :notification="notification"
          :LocationId="LocationId"
          @reload="loadNotifications()"
        /> -->
        <v-divider></v-divider>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import EmailNotification from '@/modules/Location/components/notification/EmailNotification.vue'
import SaleAlertNotification from '@/modules/Location/components/notification/SaleAlertNotification.vue'
import InvoiceDeleteNotification from '@/modules/Location/components/notification/InvoiceDeleteAlert.vue'
import locationService from '@/modules/Location/service.js'
import settingsService from '../../Settings/service'

export default {
  name: 'location-view-notifications',
  props: ['LocationId', 'location'],
  data() {
    return {
      notifications: {},
      isLoading: false,
    }
  },
  components: {
    EmailNotification,
    SaleAlertNotification,
    InvoiceDeleteNotification,
  },
  async created() {
    await this.loadNotifications()
  },
  methods: {
    async loadNotifications() {
      this.isLoading = true
      await settingsService.Notification.getAll().then(async (response) => {
        await Promise.all(
          response.data.map((notification) => {
            this.notifications[notification.id] = notification
          }),
        )
      })
      await locationService.Settings.Notifications.get(this.LocationId).then(
        async (response) => {
          this.currentNotifications = response.data

          await Promise.all(
            response.data.map((setting) => {
              if (this.notifications[setting.NotificationId]) this.notifications[setting.NotificationId].NotificationSetting = setting
            }),
          )
          // console.log('s',response.data);
          if (response.data != '') {
            if (response.data[0].metadata) {
              if (
                response.data[0].metadata.emailList
                  ? response.data[0].metadata.emailList.length
                  : '0' > 0
              ) {
                this.Emails = 'View Emails'
              }
            }
          } else {
            this.Emails = 'Add Emails'
            // this.clear()
          }
        },
      )
      this.isLoading = false
    },
  },
}
</script>

<style></style>
